import fetch from '../lib/fetch';

export const GET_INFORMATION = 'chat/interactive-survey/get-information';
export const GET_INFORMATION_REQUEST = 'chat/interactive-survey/get-information-request';
export const GET_INFORMATION_FAIL = 'chat/interactive-survey/get-information-fail';
export const getInformation = () => dispatch => {
  dispatch({ type: GET_INFORMATION_REQUEST });

  return fetch('survey', { method: 'GET' })
  .then(surveyInformation => dispatch({ type: GET_INFORMATION, surveyInformation }))
  .catch(error => dispatch({ type: GET_INFORMATION_FAIL, error }));
};

export const WILL_ANSWER = 'chat/interactive-survey/user-will-answer';
export const WONT_ANSWER = 'chat/interactive-survey/user-wont-answer';
export const willAnswer = nextAdditionalData => ({ type: WILL_ANSWER, nextAdditionalData });
export const wontAnswer = () => ({ type: WONT_ANSWER });

export const ANSWER_ADDITIONAL_DATA = 'chat/interactive-survey/answer-additional-data';
export const answerAdditionalData = (nextAdditionalData, index, additionalDataId, answer, textualAnswer) => ({
  type: ANSWER_ADDITIONAL_DATA, answer, textualAnswer, additionalDataId, nextAdditionalData, index,
});

export const SUBMIT = 'chat/interactive-survey/submit';
export const SUBMIT_REQUEST = 'chat/interactive-survey/submit-request';
export const SUBMIT_FAIL = 'chat/interactive-survey/submit-fail';
export const submit = (caseNumber, additionalData, surveySuccessfullySavedMessage, errorSavingSurveyMessage, surveyTextFooter) => dispatch => {
  dispatch({ type: SUBMIT_REQUEST });

  return fetch('survey/' + caseNumber, { method: 'POST', body: additionalData, expect: 'text' })
  .then(result => dispatch({ type: SUBMIT, surveySuccessfullySavedMessage, surveyTextFooter }))
  .catch(error => dispatch({ type: SUBMIT_FAIL, errorSavingSurveyMessage }));
}



// WEBPACK FOOTER //
// ./actions/chat/interactiveSurvey.js